import { formatAxiosErrorForSentry } from '@/utils/formatAxiosErrorForSentry'

export default function ({ $axios, $sentry }) {
  $axios.onError(error => {
    const method = error?.config?.method.toUpperCase()
    const url = error?.config?.url
    const status = error?.response?.status

    $sentry.captureException(new Error(`[${method}] ${url} failed ${status}`), {
      tags: { component: error?.config?.__component || 'AxiosRequest' },
      extra: {
        apiError: formatAxiosErrorForSentry(error),
      },
    })

    return Promise.reject(error)
  })
}
